/**
 * K|KASA Search Overlay
 * Full-page Lovable-style search triggered by [data-kk-search-trigger].
 * Uses Shopify's /search/suggest.json for live predictive results.
 */
(function () {
  'use strict';

  var overlay = null;
  var backdrop = null;
  var input = null;
  var closeBtn = null;
  var resultsList = null;
  var resultsLabel = null;
  var defaultHTML = '';

  function getElements() {
    if (!overlay) overlay = document.getElementById('KkSearchOverlay');
    if (!backdrop) backdrop = document.getElementById('KkSearchBackdrop');
    if (!input) input = document.getElementById('KkSearchInput');
    if (!closeBtn) closeBtn = document.getElementById('KkSearchClose');
    if (!resultsList) {
      resultsList = document.getElementById('KkSearchResults');
      if (resultsList && !defaultHTML) defaultHTML = resultsList.innerHTML;
    }
    if (!resultsLabel) resultsLabel = document.getElementById('KkSearchResultsLabel');
    return overlay;
  }

  var debounceTimer = null;
  var returnFocus = null;
  var previousOverflow = '';
  var requestSequence = 0;

  /* ── Open / Close ─────────────────────────────────────── */
  function openSearch(trigger) {
    if (!getElements()) return;
    bindInputEvents();
    if (overlay.classList.contains('is-open')) return;
    returnFocus = trigger && trigger.closest('#KkMobileMenu')
      ? document.getElementById('KkBurgerBtn') : trigger;
    previousOverflow = document.body.style.overflow;
    overlay.removeAttribute('inert');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      if (input) {
        input.focus();
        input.select();
      }
    }, 50);
  }

  function closeSearch(restoreFocus) {
    if (!getElements()) return;
    if (!overlay.classList.contains('is-open')) return;
    clearTimeout(debounceTimer);
    requestSequence++;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('inert', '');
    overlay.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = previousOverflow;
    if (input) input.value = '';
    resetResults();
    if (restoreFocus !== false && returnFocus && returnFocus.isConnected) returnFocus.focus();
  }

  // Expose globally on window
  window.kkOpenSearch = openSearch;
  window.kkCloseSearch = closeSearch;

  function resetResults() {
    if (resultsList && defaultHTML) resultsList.innerHTML = defaultHTML;
    if (resultsLabel) resultsLabel.textContent = 'Suggested pieces';
  }

  /* ── Bind triggers (use delegation on document for safety) ── */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-kk-search-trigger]');
    if (trigger) {
      e.preventDefault();
      openSearch(trigger);
      return;
    }

    // Close on backdrop click
    if (e.target === backdrop || e.target.closest('.kk-search-backdrop')) {
      closeSearch(true);
      return;
    }

    // Close button (X icon or CANCEL button)
    if (e.target.closest('#KkSearchClose, #KkSearchCancelBtn, .kk-search-overlay__cancel-btn, [data-kk-search-close]')) {
      closeSearch(true);
      return;
    }
  });

  // Escape key & navigation cleanup
  document.addEventListener('keydown', function (e) {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSearch(true); return; }
    if (e.key !== 'Tab') return;
    var items = Array.from(overlay.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (item) { return item.getClientRects().length; });
    if (!items.length) return;
    if (e.shiftKey && document.activeElement === items[0]) { e.preventDefault(); items[items.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === items[items.length - 1]) { e.preventDefault(); items[0].focus(); }
  });
  window.addEventListener('pagehide', function () { closeSearch(false); });

  var inputBound = false;

  function bindInputEvents() {
    if (inputBound || !input) return;
    inputBound = true;

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var q = input.value.trim();
      if (q.length < 2) { resetResults(); return; }
      debounceTimer = setTimeout(function () { fetchResults(q); }, 220);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = input.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      }
    });
  }

  function init() {
    getElements();
    bindInputEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Fetch from Shopify Predictive Search API ────────── */
  function fetchResults(query) {
    var sequence = ++requestSequence;
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (sequence !== requestSequence || !overlay.classList.contains('is-open') || !input || input.value.trim() !== query) return;
        var products = (data.resources &&
                        data.resources.results &&
                        data.resources.results.products) || [];
        renderResults(products, query);
      })
      .catch(function () { /* silently ignore network errors */ });
  }

  function renderResults(products, query) {
    if (!resultsList) return;

    if (resultsLabel) {
      resultsLabel.textContent = products.length + ' result' + (products.length === 1 ? '' : 's');
    }

    if (products.length === 0) {
      resultsList.innerHTML = '<li class="kk-search-overlay__no-results">No pieces match \u201c' +
        escapeHtml(query) + '\u201d. Try a colour, fabric or silhouette.</li>';
      return;
    }

    resultsList.innerHTML = products.map(function (p) {
      var img = p.image
        ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" class="kk-search-overlay__product-img" loading="lazy">'
        : '';
      return '<li class="kk-search-overlay__item">' +
        '<a href="' + escapeHtml(p.url) + '" class="kk-search-overlay__product-link" data-kk-search-close>' +
          '<div class="kk-search-overlay__product-img-wrap">' + img + '</div>' +
          '<div class="kk-search-overlay__product-meta">' +
            '<span class="kk-search-overlay__product-title">' + escapeHtml(p.title) + '</span>' +
            '<span class="kk-search-overlay__product-price">' + escapeHtml(p.price) + '</span>' +
          '</div>' +
        '</a></li>';
    }).join('');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

})();
